import React from 'react';
import ReactDOM from 'react-dom/client';
import './core-ui/index.css';
import './core-ui/reset.css'
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
